
export enum SubjectType {
    Core = 1,
    Elective = 2,
}
